import { stringToHex } from 'viem'
import { mainnet } from 'viem/chains'

import { DelegateAction } from '../types'
import { delegateRegistryConfig } from '@/config/contracts-generated'
import { getContractAddress } from '@/domain/hooks/useContractAddress'
import { ensureConfigTypes } from '@/features/actions/logic/transactions/useWrite'
import { ActionConfig, ActionContext } from '@/features/actions/logic/types'
import { spkGovernanceSnapshotSpaceName } from '@/features/spk/governance/config'
import { delegateQueryKey } from '@/features/spk/governance/dialogs/delegate/logic/delegateQuery'

export function createDelegateActionConfig(action: DelegateAction, context: ActionContext): ActionConfig {
  const { chainId } = context

  return {
    getWriteConfig: () => {
      return ensureConfigTypes({
        abi: delegateRegistryConfig.abi,
        address: getContractAddress(delegateRegistryConfig.address, mainnet.id),
        functionName: 'setDelegate',
        args: [stringToHex(spkGovernanceSnapshotSpaceName, { size: 32 }), action.delegate],
      })
    },
    invalidates: () => [delegateQueryKey({ delegator: action.delegator, chainId })],
  }
}
